module.exports = __webpack_public_path__ + "img/IMG_2671_L_Foamcore_MockedUp.bbe8db80.jpg";